import { cn } from '@/lib/utils';
import { useTranslation } from '../../../hooks/useTranslation';
import { StatusActiveIcon, StatusInactiveIcon } from '../../icons/StatusIcons';

type PillStatus = 'active' | 'inactive';

interface ProductStatusPillProps {
  status: PillStatus;
  className?: string;
}

const PILL_BASE = 'inline-flex w-[123px] items-center justify-center gap-1.5 rounded-xs border p-1.5 text-xs font-semibold leading-[1.25] whitespace-nowrap';

const PILL_VARIANTS: Record<PillStatus, { className: string; labelKey: string; Icon: typeof StatusActiveIcon }> = {
  active: {
    className: 'border-yield-positive-border bg-yield-positive-bg text-yield-positive',
    labelKey: 'filters.active',
    Icon: StatusActiveIcon,
  },
  inactive: {
    className: 'border-grey-light bg-dinnerplate-white-light text-grey',
    labelKey: 'filters.inactive',
    Icon: StatusInactiveIcon,
  },
};

export function ProductStatusPill({ status, className }: ProductStatusPillProps) {
  const { t } = useTranslation();
  const { className: variantClassName, labelKey, Icon } = PILL_VARIANTS[status];

  return (
    <div className={cn(PILL_BASE, variantClassName, className)}>
      <Icon className="size-4 flex-shrink-0" />
      {t(labelKey)}
    </div>
  );
}
